import React, { lazy, Suspense, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useRecoilState, useRecoilValue } from "recoil";
import { get, lowerCase } from "lodash";
import { useHistory, useParams } from "react-router";
import { permissionsSet } from "Recoil/LoggedInUserDetail/selector";
import { reportSelectedTabState } from "Recoil/SelectedTab/atom";
import { HorizontalTab, LoadingWidget } from "Components/index";
import { Tabs } from "./constants";
import { checkArrayLength } from "../../utils";
import { useStyles } from "./styles";
import { useKendoGrid } from "Hooks/report/useKendoGrid";
import { menuDrawerState } from "Recoil/General/atom";
const PageHeader = lazy(() => import("Components/PageHeader"));
const DepartmentReport = lazy(() => import("Modules/Reports/DepartmentReport"));
const CoachingReport = lazy(() => import("Modules/Reports/CoachingReport"));
const ExecutiveSnapshot = lazy(() =>
  import("Modules/Reports/ExecutiveSnapshot")
);
const SuccessStoryKendo = lazy(() =>
  import("Modules/Reports/SuccessStoryKendo")
);
const SuccessStoriesReport = lazy(() =>
  import("Modules/Reports/SuccessStoriesReport")
);

const Reports = () => {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();

  const location = history.location.pathname;
  const { reportFilterData } = useKendoGrid();
  const permissions = useRecoilValue(permissionsSet);
  let tabs = permissions && Tabs(permissions);
  const [selectedTab, setSelectedTab] = useRecoilState(reportSelectedTabState);
  useEffect(() => {
    if (checkArrayLength(tabs) && location) {
      const value = tabs.find((res) =>
        location.includes(lowerCase(get(res, "key", "")))
      );
      get(value, "key", "") ? setSelectedTab(value) : setSelectedTab(tabs[0]);
    }
  }, [checkArrayLength(tabs), location]);

  const getInitialData = () => {
    reportFilterData({
      variables: {},
    });
  };

  useEffect(() => {
    getInitialData();
  }, []);

  const isDrawerOpen = useRecoilValue(menuDrawerState);

  return (
    <Suspense 
    fallback={
      <div style={{ textAlign: "center", padding: "5rem" }}>
        <LoadingWidget color="grey" pageLoader={true} />
      </div>
    }>
    <Box width="100%" className={`${classes.content} content-area`}>
      <PageHeader title="Reports" containerWidth="lg" />
      <HorizontalTab
        className={`${classes.reportTabs} ${
          isDrawerOpen ? classes.updateTabPosition : ""
        } mui-fixed`}
        showCount={false}
        tabs={tabs}
        pendoUrl={true}
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
        getTabContents={() => (
          <Box>
            {selectedTab.key === "SUCCESSSTORIES" ? (
              id ? (
                <SuccessStoriesReport />
              ) : (
                <SuccessStoryKendo action={"successStory"} />
              )
            ) : selectedTab.key === "PERFORMANCEREVIEW" ? (
              id ? (
                <SuccessStoriesReport />
              ) : (
                <SuccessStoryKendo action={"performanceReview"} />
              )
            ) : selectedTab.key === "DEPARTMENTS" ? (
              <DepartmentReport />
            ) : selectedTab.key === "COACHING" ? (
              <CoachingReport />
            ) : (
              <ExecutiveSnapshot />
            )}
          </Box>
        )}
      />
    </Box>
    </Suspense>
  );
};

export default Reports;
